import React, { createContext, useContext } from "react"

// La vitrine de biens d'un gabarit (destination, seo-collection, vacances)
// est fournie par la PAGE, qui connaît sa langue : le gabarit n'importe plus
// les variantes FR et EN à la fois, et chaque page ne charge que les biens de
// sa langue (performance, 20/10/2026 — 11,5 Mo → ~4,5 Mo de données sur les
// pages destination). Sans fournisseur, rien n'est rendu.
const ListingsPreviewContext = createContext(null)

export const ListingsPreviewProvider = ({ component, children }) => (
  <ListingsPreviewContext.Provider value={component}>{children}</ListingsPreviewContext.Provider>
)

const ListingsPreviewSlot = props => {
  const Component = useContext(ListingsPreviewContext)
  return Component ? <Component {...props} /> : null
}

export default ListingsPreviewSlot
